import { App_Url_New } from "@/shared/common/static";
import { axiosInstance } from "@/shared/lib/axiosInstance";

import type { DashboardData, DashboardOption } from "../types";

type DashboardParams = {
  filterType: string;
  startDate?: string;
  endDate?: string;
  agentId?: string | number;
  lobId?: string | number;
};

export const dateFilterOptions: DashboardOption[] = [
  { value: "current_month", label: "Current Month" },
  { value: "previous_month", label: "Previous Month" },
  { value: "current_quarter", label: "Current Quarter" },
  { value: "previous_quarter", label: "Previous Quarter" },
  { value: "current_fy", label: "Current Fiscal Year" },
  { value: "previous_fy", label: "Previous Fiscal Year" },
  { value: "custom", label: "Custom Date Range..." },
];

export async function fetchDashboardData({
  filterType,
  startDate,
  endDate,
  agentId,
  lobId,
}: DashboardParams): Promise<DashboardData | null> {
  const params: Record<string, string | number> = { filter_type: filterType };

  if (filterType === "custom" && startDate && endDate) {
    params.start_date = startDate;
    params.end_date = endDate;
  }
  if (agentId) params.agent_id = agentId;
  if (lobId) params.lob_id = lobId;

  const response = await axiosInstance.get(App_Url_New.ApiEndPoint.dashboardCount, {
    params,
  });

  return response.data?.status === "success" ? response.data.data : null;
}

export async function fetchAgentOptions(): Promise<DashboardOption[]> {
  const response = await axiosInstance.post(App_Url_New.ApiEndPoint.teamMembers);
  const agents = Array.isArray(response.data) ? response.data : [];

  return [
    { value: "", label: "All Agents" },
    ...agents.map((agent: any) => ({
      value: String(agent.employee?.id || agent.id || ""),
      label: agent.employee?.full_name || "Unknown Agent",
    })),
  ];
}

export async function fetchLobOptions(): Promise<DashboardOption[]> {
  const response = await axiosInstance.get(App_Url_New.ApiEndPoint.filters);
  const lobs = Array.isArray(response.data) ? response.data : [];

  return [
    { value: "", label: "All Products" },
    ...lobs.map((lob: any) => ({
      value: String(lob.id || ""),
      label: lob.display_name || lob.name || "Unknown Product",
    })),
  ];
}
